export enum StatusAgent {
    Online = "b6772d5d-47f9-4987-b355-eae070198406",
    Offline = "dd31811e-c7ea-4928-b190-a5afe063c957",
    Ausente = "755fb1c9-1e76-4dfa-9715-46650c152680"
}